<template>
	<div class="container">
		<div class="main_box">
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="text"
			>
				宝瑞源生物技术(北京)有限公司自建立之初，一直以科研为基础，奉献创造价值为信念，获得了行业内多项专利授权和资质证书
			</div>
			<div
				v-if="photoList.length > 0"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="swiper_box"
			>
				<swiper :options="swiperOption">
					<swiper-slide v-for="(value, index) in photoList">
						<div class="swiper_el">
							<img lazy-load :src="value.thumb" />
							<div class="tit">{{ value.title }}</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { ImagePreview } from 'vant';  //图片放大
var vm = null;
export default {
	components:{
		swiper,
		swiperSlide,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			swiperOption:{
			    autoplay: true,
				loop: true,
				initialSlide: null, 
				speed: 1500,
				effect: "coverflow",
				coverflowEffect: {
					rotate: 0,
					stretch: -40,
					depth: 300,
					modifier: 3,
					initialSlide: 1,
					slideShadows:false,  
				},
				loopAdditionalSlides: 0,
				centeredSlides: true,
				slidesPerView: 1.3,
				loopedSlides: 5,
				pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplayDisableOnInteraction: false,
				on: {
					click: function () {
						vm.showBigImg(this.realIndex);
					}
				}
			},
			photoList: [
				{ id: 2, title: '北京市“专精特新”中小企业', thumb: require('@/assets/img_public/about/honor/honor02.webp') },
				{ id: 3, title: '中关村高新技术企业', thumb: require('@/assets/img_public/about/honor/honor03.webp') },
				{ id: 5, title: '9001 质量管理体系认证证书', thumb: require('@/assets/img_public/about/honor/honor05.webp') },
				{ id: 4, title: '高新技术企业', thumb: require('@/assets/img_public/about/honor/honor04.webp') },
				{ id: 1, title: 'ISO 13485', thumb: require('@/assets/img_public/about/honor/honor01.webp') }
			]
		}
	},
	created(){
		let that = this;
		vm = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//查看大图
		showBigImg(value) {
			let that = this;
			let url = that.photoList[value].thumb;
			ImagePreview({
				closeable: true,
				showIndicators: false,
				showIndex: false,
				images: [url],
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	.text{
		padding: 0 16px;
		text-align: center;
		line-height: 1.8;
	}
}
</style>
<style scoped>
.swiper_box{width:100%;margin-bottom: 50px;padding-top: 30px;}
.swiper_box .swiper-container{width:100%;height:100%;}
.swiper_box .swiper_el{width:100%;height:100%;position:relative;}
.swiper_box .swiper-slide{width:100%;height:100%;}
.swiper_box .swiper-slide img{width:100%;border-radius: 8px;}
.swiper_box .tit{
	padding: 20px 16px 0 16px;
	text-align: center;
	font-size: 16px;
	color: #333333;
}
</style>